import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fotografia-layout',
  templateUrl: './fotografia-layout.component.html',
  styleUrls: ['./fotografia-layout.component.scss']
})
export class FotografiaLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
